<!-- 订单备注 -->
<template>
  <BaseFormItem class="remark" :label="label">
    <BaseInput
      v-model="val"
      type="textarea"
      width="410px"
      resize="none"
      :row="3"
      @input="handleEmit"
    />
    <p class="remark__tips">* 请勿将加工要求填写在这</p>
  </BaseFormItem>
</template>

<script>
import { labelWarp } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    label() {
      // 换行展示label
      return labelWarp('SMT订单备注', 3)
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.remark {
  .remark__tips {
    margin-top: 4px;
    line-height: 1.5;
    font-size: $--font-size-small;
    color: $--color-warning;
  }
}
</style>